import getRequest from '@/api'

const request = getRequest(process.env.VUE_APP_SYSTEM_API)

/**
 * 商户信息
 */
export function getMerchantInfo(data) {
  return request.get('tenant/tenantByUrl', data)
}

/**
 * 注册
 */
export function register(data) {
  return request.post('register/accountAndSupplier', data)
}

/**
 * 登录
 */
export function userLogin(data) {
  return request.post('login', data, { disableToken: true })
}

/**
 * token自动登录
 */
export function userLoginToken(data) {
  return request.post('login', data)
}

/**
 * 退出登录
 */
export function userLogout() {
  return request.get('loginOut')
}

/**
 * 获取手机验证码
 */
export function sendCode(data) {
  return request.get('sms/code/send', data)
}

/**
 * 修改密码
 */
export function modifyPassword(data) {
  return request.put('user/pwd', data)
}

/**
 * 重置密码
 */
export function resetPassword(data) {
  return request.post('account/password/reset', data)
}

/**
 * 修改手机号码
 */
export function modifyPhone(data) {
  return request.post('account/updatePhone', data)
}

/**
 * 用户权限
 */
export function userPermission() {
  return request.get('getPermissions', null, {
    disableToast: true,
    timeout: 1000
  })
}